import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootDispatch, RootState } from 'storage/store';
import { Button, Container, useMediaQuery } from '@mui/material';

import appTheme from 'App.theme';
import { ScrollableContent } from 'components/ScrollableContent';
import StyledModal from './styled/StyledModal';
import RegulationContent from './components/RegulationContent';

const ADDITIONAL_HEIGHT_TU_CUT_MOBILE = 42;
const ADDITIONAL_HEIGHT_TU_CUT_TABLET_AND_DESKTOP = 110;
const INITIAL_HEIGHT = 0;

const Regulation = () => {
  const { t } = useTranslation();

  const [windowHeight, setWindowHeight] = useState<number>(INITIAL_HEIGHT);
  const handleResize = () => {
    setWindowHeight(window.innerHeight);
  };
  useEffect(() => {
    setWindowHeight(window.innerHeight);
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const mobileBreakpoint = useMediaQuery(appTheme.breakpoints.down('md'));
  const additionalHeightToCut = mobileBreakpoint
    ? ADDITIONAL_HEIGHT_TU_CUT_MOBILE
    : ADDITIONAL_HEIGHT_TU_CUT_TABLET_AND_DESKTOP;
  const isModalOpen = useSelector(
    ({ modals }: RootState) => modals.isRegulationOpen
  );
  const { modals } = useDispatch<RootDispatch>();
  const button = t('REGULATION_BUTTON');
  const description = t('REGULATION_SCROLLBUTTON');
  return (
    <StyledModal
      open={isModalOpen}
      fullScreen={mobileBreakpoint}
      onClose={modals.changeRegulationsVisibility}
    >
      <Container
        sx={{
          overflow: 'hidden',
          maxHeight: `${windowHeight}px`
        }}
        disableGutters
      >
        <ScrollableContent
          scrollAmount={80}
          buttonBarHeight={100}
          additionalHeightToCut={additionalHeightToCut}
          description={description}
        >
          <RegulationContent />

          <Button
            onClick={modals.changeRegulationsVisibility}
            variant="contained"
            size="large"
            sx={{ margin: '32px auto 40px 0' }}
          >
            {button}
          </Button>
        </ScrollableContent>
      </Container>
    </StyledModal>
  );
};

export default Regulation;
